import { put, call, takeLatest } from 'redux-saga/effects';
import * as APICommon from '../../services/apiCommon';
import * as SagaCommon from '../../sagas/sagasCommon';

import { 
  GET_ENTITY_INVENTORY_RETURN,
  GET_ENTITY_INVENTORY_RETURN_IN_PROGRESS,
  SET_ENTITY_INVENTORY_RETURN_LIST
 } from '../../constants/constant_action_types';

 import {
  setPurchaseReturnPagination
 } from '../../actions/actionCreatorEntityPurchase';

export function* getEntityPurchaseReturnsSaga(feathersApp) {
  yield takeLatest(GET_ENTITY_INVENTORY_RETURN, callGetEntityPurchaseReturns, feathersApp);
}

function* callGetEntityPurchaseReturns(feathersApp, action) {
  try {
    const { filters = {} } = action;

    yield put({ type: GET_ENTITY_INVENTORY_RETURN_IN_PROGRESS });
    const dataParams = {
      filters: { ...filters },
      list_type: 'inventory_return'
    }

    const entityPurchaseReturnResult = yield call(APICommon.getListData, feathersApp, dataParams);

    let entityPurchaseReturns = entityPurchaseReturnResult.docs;

    yield put(setPurchaseReturnPagination(null, null, entityPurchaseReturnResult.total));
    yield put({ type: SET_ENTITY_INVENTORY_RETURN_LIST, list: entityPurchaseReturns });

  } catch (error) {
    yield SagaCommon.showErrorListTable(error);
  }
}